module.exports = __webpack_public_path__ + "img/post-add.5d281298.svg";